import { getConfigValue } from '@/shared/config/utils';

export function getMinSessionDurationSeconds() {
    return getConfigValue('MIN_DICTATION_SESSION_DURATION_SECONDS');
}
